import type { ComboboxOptions } from "@shared-kernel/primary/shared/combobox/combobox";

export enum ORGANIZATION {
  OPERA_OFF = "opera_off",
  LES_ATELIERS_OO = "les_ateliers_oo",
}

export const ORGANIZATION_NAME: Record<ORGANIZATION, { long: string; short: string }> = {
  [ORGANIZATION.OPERA_OFF]: { long: "OPERA Off", short: "OO" },
  [ORGANIZATION.LES_ATELIERS_OO]: { long: "Les Ateliers OO", short: "LAOO" },
};

export interface OrganizationInfo {
  name: string;
  address: string;
  postalCode: string;
  city: string;
  siret: string;
}

export const ORGANIZATION_INFO: Record<ORGANIZATION, OrganizationInfo> = {
  [ORGANIZATION.OPERA_OFF]: {
    name: "OPERA Off",
    address: "111 rue de Vaugirard",
    postalCode: "75006",
    city: "Paris",
    siret: "41290588700011",
  },
  [ORGANIZATION.LES_ATELIERS_OO]: {
    name: "Les Ateliers OO",
    address: "69 rue du Faubourg Saint-Antoine",
    postalCode: "75011",
    city: "Paris",
    siret: "93261062900010",
  },
};

export const PUBLIC_SITE = {
  url: "https://lesateliersoo.fr",
  domain: "lesateliersoo.fr",
} as const;

export const OrganizationOptions: ComboboxOptions[] = Object.values(ORGANIZATION)
  .map(o => ({
    label: ORGANIZATION_NAME[o].long,
    value: o,
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
